import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { GetSingleAncillaryResponse } from "../../../../common/api/catalogue-api/ancillary/GetSingleAncillaryResponse";
import { useCatalogueAncillarySearchApi } from "../../../../common/api/catalogue-api/ancillary/useCatalogueAncillarySearchApi";
import { useAssetListingConfig } from "../../common/config/useAssetListingConfig";
import { AncillaryCatalogueEntry, mapToAncillaryCatalogueEntry } from "./AncillaryCatalogueEntry";
import { SingleAncillaryContext } from "./SingleAncillaryContext";

type SingleAncillaryProviderProps = React.PropsWithChildren<unknown>;

export const SingleAncillaryProvider: React.FC<SingleAncillaryProviderProps> = (
    props: SingleAncillaryProviderProps
) => {
    const { ancillaryId } = useParams<{ ancillaryId: string }>();

    const { children } = props;

    const { getSingleAncillary } = useCatalogueAncillarySearchApi();

    const [ancillary, setAncillary] = useState<AncillaryCatalogueEntry>(emptyAncillary);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const { listingConfig, saveListingConfig } = useAssetListingConfig();

    useEffect(() => {
        setIsLoading(true);
        getSingleAncillary(ancillaryId)
            .then((response: GetSingleAncillaryResponse) => {
                const mappedResponse = mapToAncillaryCatalogueEntry(response);

                setAncillary(mappedResponse);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [ancillaryId]);

    return (
        <SingleAncillaryContext.Provider
            value={{ ancillaryId, ancillary, isLoading, listingConfig, saveListingConfig }}
        >
            {children}
        </SingleAncillaryContext.Provider>
    );
};

const emptyAncillary: AncillaryCatalogueEntry = {
    id: "",
    title: "",
    orphaned: true,
    contentType: 0,
    version: {
        id: "",
        type: {
            id: "",
            name: ""
        },
        airlines: []
    }
};
